import { render, staticRenderFns } from "./OrderByOrderStatusPage.vue?vue&type=template&id=355f0048&scoped=true"
import script from "./OrderByOrderStatusPage.vue?vue&type=script&lang=js"
export * from "./OrderByOrderStatusPage.vue?vue&type=script&lang=js"
import style0 from "./OrderByOrderStatusPage.vue?vue&type=style&index=0&id=355f0048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355f0048",
  null
  
)

export default component.exports